import React, { Component } from 'react';
import { connect } from 'react-redux';
import lang from '../../constants/Languages.js';
import { HashLink as Link } from 'react-router-hash-link';

import LoadingIndicator from './../LoadingIndicator.js';
import DetailsListItem from './../characteristics-details/DetailsListItem.js';
import DetailsListItemSingle from './../characteristics-details/DetailsListItemSingle.js';

import numberWithSpaces from '../../scripts/NumberWithSpaces.js';

import chevronDownAccent from '../../assets/icons/chevron-down-accent.svg';
import chevronUpAccent from '../../assets/icons/chevron-up-accent.svg';

class DetailsLocation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpened: false,
			scrolled: false
		};
	};

	setActiveElem = (to) => {
		if (to !== this.state.to) {
			this.setState({ to: to });
		}
	};

	scrollTo = (elem, to) => {
		elem.scrollTop = to;
	};

	componentDidUpdate(prevProps, prevState) {
		const { to, scrolled } = this.state;

		if (to && this.activeElemContainer && (!scrolled || to !== prevState.to)) {
			this.setState({ scrolled: true });
			this.scrollTo(this.activeElemContainer, to - this.activeElemContainer.getBoundingClientRect().top + 15);
		}
	};

	render() {
		const { clang, isLoading, isError, rootsData, detailsData, getImgField, getFieldChildren, setIsTouched, isTouched, currentHeading, rootsPath } = this.props;
		const { isOpened } = this.state;

		const currentDomain = rootsData && detailsData ? rootsData.filter(root => root.domainCode === detailsData.domainCode)[ 0 ] : {};

		if (!currentDomain) {
			return null;
		}

		return (
			<div>
				{ !isLoading && !isError &&
					<h2 className="headings-details__desc__title--location"
						dangerouslySetInnerHTML={ { __html: lang[ clang ].headings_details.location } }></h2> }
				{/* {!isLoading && isError &&
                  <div className="structure__error">{lang[clang].characteristics.error}</div>} */}
				{ isLoading && !isError &&
					<LoadingIndicator /> }
				{ !isLoading && !isError &&
					<div className="headings-details__list">
						<div className="headings-details__list-header">
							<div className="structure">
								<div className="structure__box--left">
									{ getImgField(detailsData.domainCode) }
									<span className="structure__box--left-text">{ lang[ clang ].headings_details.domain }:</span>
									<strong className="structure__box--left-field"> { lang[ clang ].characteristics[ detailsData.domainCode ] }</strong>
									{ currentDomain.count &&
										<span className="structure__box--left-number"> ({ numberWithSpaces(currentDomain.count) })</span> }
								</div>
								<div className="structure__box--right-container">
									<div className="structure__box--right">
										<span className="structure__box--left-text">{ lang[ clang ].headings_details.heading }:</span>
										{ rootsPath && rootsPath.length > 0 &&
											<ul className="headings-details__roots-list">
												{ rootsPath.slice(1).map((root, index) =>
													<li key={ index } className="headings-details__roots-list__item">
														{ index !== rootsPath.length - 1 ?
															<Link to={ `/headings/about/details?q=*&area=all&HEADINGS[0]=${root.id}` }
																className="headings-details__roots-list__link"
																title={ root.label }>
																{ index !== 0 && <span className="headings-details__roots-list__separator">></span> }
																<span className="headings-details__roots-list__label">{ root.label }</span>
															</Link>
															: <span><span className="headings-details__roots-list__separator">></span>{ root.label }</span> }
													</li>) }
											</ul> }
									</div>
									<div className="structure__box__dropdown">
										<button onClick={ () => this.setState({ isOpened: !this.state.isOpened }) }
											className="structure__box__dropdown-button"
											title={ lang[ clang ].headings_details.change_domain }>
											{ lang[ clang ].headings_details.change_domain }
											{ !isOpened && <img className="structure__info__button-img" src={ chevronDownAccent } alt="" /> }
											{ isOpened && <img className="structure__info__button-img" src={ chevronUpAccent } alt="" /> }
										</button>
										{ isOpened &&
											<ul className="headings-details__dropdown-list">
												{ rootsData && rootsData.map((root, index) =>
													<li key={ index } className="headings-details__dropdown-list__item">
														<Link to={ `/headings/about#${root.domainCode}` }
															className="headings-details__dropdown-list__link"
															scroll={ el => el.scrollIntoView({ block: 'start' }) }>
															{ lang[ clang ].characteristics[ root.domainCode ] }
														</Link>
													</li>) }
											</ul> }
									</div>
								</div>
							</div>
						</div>
						<div className="headings-details__list-container" ref={ (activeElemContainer) => this.activeElemContainer = activeElemContainer }>
							{ currentDomain.children && currentDomain.children.length > 0 && !isLoading && !isError &&
								<ul className="structure__list">
									{ currentDomain.children.map((child, index) => child.expansible || (child.children && child.children.length > 0) ?
										<DetailsListItem key={ index } { ...child }
											setIsTouched={ setIsTouched }
											currentHeading={ currentHeading }
											isTouched={ isTouched }
											setActiveElem={ this.setActiveElem }
											getFieldChildren={ getFieldChildren } />
										: <DetailsListItemSingle setActiveElem={ this.setActiveElem } currentHeading={ currentHeading } key={ index } { ...child } />) }
								</ul> }
						</div>
					</div> }
			</div>
		);
	};
};


const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(DetailsLocation);



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsLocation.js